import { render, staticRenderFns } from "./question-item.vue?vue&type=template&id=70112697&scoped=true&"
import script from "./question-item.vue?vue&type=script&lang=js&"
export * from "./question-item.vue?vue&type=script&lang=js&"
import style0 from "./question-item.vue?vue&type=style&index=0&id=70112697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70112697",
  null
  
)

export default component.exports